
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire49a6"];
var parcelRegister = parcelRequire.register;
parcelRegister("iuxaw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $j951X = parcelRequire("j951X");

var $d764c1f160d89f41$var$_classnames = $d764c1f160d89f41$var$_interopRequireDefault((parcelRequire("g3elz")));

var $gYPan = parcelRequire("gYPan");

var $d764c1f160d89f41$var$localeDataSkipMenu = $d764c1f160d89f41$var$_interopRequireWildcard((parcelRequire("f3fhD")));

var $d764c1f160d89f41$var$_react = $d764c1f160d89f41$var$_interopRequireWildcard((parcelRequire("7eprg")));

var $7MkSZ = parcelRequire("7MkSZ");

function $d764c1f160d89f41$var$_getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    $d764c1f160d89f41$var$_getRequireWildcardCache = function() {
        return cache;
    };
    return cache;
}
function $d764c1f160d89f41$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d764c1f160d89f41$var$_getRequireWildcardCache();
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d764c1f160d89f41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/ const $d764c1f160d89f41$var$ShellSkipMenu = /*#__PURE__*/ $d764c1f160d89f41$var$_react.default.memo(({ items: items = null, onVisibilityChange: onVisibilityChange, open: open, trackSkipMenuActions: trackSkipMenuActions })=>{
    const { formatMessage: formatMessage } = (0, $7MkSZ.default)();
    const itemKey = items && items.length === 1 ? items[0].id : "fallback";
    const ref = (0, $d764c1f160d89f41$var$_react.useRef)(null);
    return /*#__PURE__*/ $d764c1f160d89f41$var$_react.default.createElement("div", {
        className: (0, $d764c1f160d89f41$var$_classnames.default)("spectrum-Shell-skipMenu", {
            skipMenuOpen: open
        }),
        onBlur: ()=>onVisibilityChange(false),
        onFocus: (e)=>{
            onVisibilityChange(true, e);
            document.dispatchEvent(new CustomEvent("getSkipMenu", {
                detail: {}
            }));
        }
    }, /*#__PURE__*/ $d764c1f160d89f41$var$_react.default.createElement($j951X.ActionButton, {
        UNSAFE_className: "skipMenu-listItem",
        "data-skip-menu": itemKey,
        onPress: (e)=>{
            trackSkipMenuActions(e);
            ref.current.UNSAFE_getDOMNode().dispatchEvent(new CustomEvent("click", {
                bubbles: true
            }));
        },
        ref: ref
    }, formatMessage({
        defaultMessage: "Skip to main content",
        description: "Label for button to skip focus to main content",
        id: "shellSkipMenuMainContent"
    })));
});
$d764c1f160d89f41$var$ShellSkipMenu.displayName = "ShellSkipMenu";
const $d764c1f160d89f41$var$I18nShellSkipMenu = (props)=>/*#__PURE__*/ $d764c1f160d89f41$var$_react.default.createElement($gYPan.IntlProvider, {
        locale: props.locale,
        messages: $d764c1f160d89f41$var$localeDataSkipMenu
    }, /*#__PURE__*/ $d764c1f160d89f41$var$_react.default.createElement($d764c1f160d89f41$var$ShellSkipMenu, props));
var $d764c1f160d89f41$var$_default = $d764c1f160d89f41$var$I18nShellSkipMenu;
module.exports.default = $d764c1f160d89f41$var$_default;

});
parcelRegister("f3fhD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "en_US", {
    enumerable: true,
    get: function() {
        return $af52fdca210f17d8$var$_en_us.default;
    }
});
Object.defineProperty(module.exports, "de_DE", {
    enumerable: true,
    get: function() {
        return $af52fdca210f17d8$var$_de_de.default;
    }
});
Object.defineProperty(module.exports, "es_ES", {
    enumerable: true,
    get: function() {
        return $af52fdca210f17d8$var$_es_es.default;
    }
});
Object.defineProperty(module.exports, "fr_FR", {
    enumerable: true,
    get: function() {
        return $af52fdca210f17d8$var$_fr_fr.default;
    }
});
Object.defineProperty(module.exports, "it_IT", {
    enumerable: true,
    get: function() {
        return $af52fdca210f17d8$var$_it_it.default;
    }
});
Object.defineProperty(module.exports, "ja_JP", {
    enumerable: true,
    get: function() {
        return $af52fdca210f17d8$var$_ja_jp.default;
    }
});
Object.defineProperty(module.exports, "ko_KR", {
    enumerable: true,
    get: function() {
        return $af52fdca210f17d8$var$_ko_kr.default;
    }
});
Object.defineProperty(module.exports, "pt_BR", {
    enumerable: true,
    get: function() {
        return $af52fdca210f17d8$var$_pt_br.default;
    }
});
Object.defineProperty(module.exports, "zh_CN", {
    enumerable: true,
    get: function() {
        return $af52fdca210f17d8$var$_zh_cn.default;
    }
});
Object.defineProperty(module.exports, "zh_TW", {
    enumerable: true,
    get: function() {
        return $af52fdca210f17d8$var$_zh_tw.default;
    }
});

var $af52fdca210f17d8$var$_en_us = $af52fdca210f17d8$var$_interopRequireDefault((parcelRequire("5xcBJ")));

var $af52fdca210f17d8$var$_de_de = $af52fdca210f17d8$var$_interopRequireDefault((parcelRequire("9EO0u")));

var $af52fdca210f17d8$var$_es_es = $af52fdca210f17d8$var$_interopRequireDefault((parcelRequire("7fb0w")));

var $af52fdca210f17d8$var$_fr_fr = $af52fdca210f17d8$var$_interopRequireDefault((parcelRequire("gZfEc")));

var $af52fdca210f17d8$var$_it_it = $af52fdca210f17d8$var$_interopRequireDefault((parcelRequire("4oroM")));

var $af52fdca210f17d8$var$_ja_jp = $af52fdca210f17d8$var$_interopRequireDefault((parcelRequire("kyWlx")));

var $af52fdca210f17d8$var$_ko_kr = $af52fdca210f17d8$var$_interopRequireDefault((parcelRequire("kKUEV")));

var $af52fdca210f17d8$var$_pt_br = $af52fdca210f17d8$var$_interopRequireDefault((parcelRequire("V2MyT")));

var $af52fdca210f17d8$var$_zh_cn = $af52fdca210f17d8$var$_interopRequireDefault((parcelRequire("bAkCU")));

var $af52fdca210f17d8$var$_zh_tw = $af52fdca210f17d8$var$_interopRequireDefault((parcelRequire("dJjWN")));
function $af52fdca210f17d8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("5xcBJ", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"shellSkipMenuMainContent":"Skip to main content"}');

});

parcelRegister("9EO0u", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"shellSkipMenuMainContent":"Zum Hauptinhalt springen"}');

});

parcelRegister("7fb0w", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"shellSkipMenuMainContent":"Saltar al contenido principal"}');

});

parcelRegister("gZfEc", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"shellSkipMenuMainContent":"Acc\xe9der directement au contenu principal"}');

});

parcelRegister("4oroM", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"shellSkipMenuMainContent":"Vai al contenuto principale"}');

});

parcelRegister("kyWlx", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"shellSkipMenuMainContent":"\u30E1\u30A4\u30F3\u30B3\u30F3\u30C6\u30F3\u30C4\u306B\u30B9\u30AD\u30C3\u30D7"}');

});

parcelRegister("kKUEV", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"shellSkipMenuMainContent":"\uC8FC\uC694 \uCEE8\uD150\uCE20\uB85C \uAC74\uB108 \uB6F0\uAE30"}');

});

parcelRegister("V2MyT", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"shellSkipMenuMainContent":"Pular para o conte\xfado principal"}');

});

parcelRegister("bAkCU", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"shellSkipMenuMainContent":"\u8DF3\u81F3\u4E3B\u8981\u5185\u5BB9"}');

});

parcelRegister("dJjWN", function(module, exports) {
"use strict";
module.exports = JSON.parse('{"shellSkipMenuMainContent":"\u8DF3\u81F3\u4E3B\u8981\u5167\u5BB9"}');

});




//# sourceMappingURL=ShellSkipMenu.a1aa6983.js.map
